
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { Dropdown } from 'office-ui-fabric-react/lib/Dropdown';
import includes from 'lodash/includes';
import reverse from 'lodash/reverse';

import Text from '../../common/client/components/Text';

import analyzeGetActions from '../../sagas/analyze';
import opsubGetActions from '../../sagas/opsub';
import { getDirection, getIsknDate, getIsknDateChecked, getOpsubItem } from '../../reducers/analyze';
import { getIsknDate as getOpsubIsknDate, getOpsubItems } from '../../reducers/opsub';
import { getProject, getProjectKatuzeItems } from '../../reducers/project';

import IsknDataComboBox from '../common/IsknDataComboBox';

import OverviewPanel from './OverviewPanel';
import SelectOpsubComboBox from '../common/iskn/SelectOpsubComboBox';
import IsknDataCheckbox from '../common/IsknDataCheckbox';

const classNames = mergeStyleSets({
    content: {
        paddingTop: 16
    },
    analyzeButton: {
        paddingTop: 0
    },
    isknDate: {
        padding: 4
    }
});

const OverviewPanelOpsub = (props) => {

    const dispatch = useDispatch();
    const analyzeActions = analyzeGetActions(dispatch);
    const opsubActions = opsubGetActions(dispatch);

    const token = useSelector(state => {
        return state.auth.data ? state.auth.data.user.token : null;
    });

    const project = useSelector(state => getProject(state.project));
    const projectKatuzeItems = useSelector(state => getProjectKatuzeItems(state.project));

    const opsubItems = useSelector(state => getOpsubItems(state.opsub));
    const opsubIsknDate = useSelector(state => getOpsubIsknDate(state.opsub));
    const direction = useSelector(state => getDirection(state.analyze));
    const isknDate = useSelector(state => getIsknDate(state.analyze));
    const isknDatesChecked = useSelector(state => getIsknDateChecked(state.analyze));
    const opsubItem = useSelector(state => getOpsubItem(state.analyze));

    const iskn = useSelector(state => state.iskn);

    useEffect(() => {
        if (isknDate && ((opsubItems.length === 0) || (isknDate !== opsubIsknDate))) {
            opsubActions.getOpsub(
                token, project.id, projectKatuzeItems.map(item => item.kod), isknDate
            );
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isknDate]);

    const canAnalyze = () => {
        return (isknDatesChecked.length > 1);
    }

    const getIsknDatesForAnalyze = () => {
        const isknDates = (direction === 'forward')
            ? [...iskn.data]
            : reverse([...iskn.data]);

        const isknDatesForAnalyze = isknDates.reduce((previous, current) => {
            if (previous.length > 0) {
                return [...previous, current.date];
            } else {
                if (current.date === isknDate) {
                    return [current.date];
                } else {
                    return previous;
                }
            }
        }, []);

        return isknDatesForAnalyze;
    }

    const handleClickAnalyze = () => {

        let isknDatesForAnalyze = getIsknDatesForAnalyze().filter(item => {
            return includes(isknDatesChecked, item);
        });

        analyzeActions.getAnalyze(
            token, project.id,
            projectKatuzeItems.map(item => parseInt(item.kod)),
            isknDatesForAnalyze, opsubItem.id, direction
        );
    }

    const handleChangeDirection = (event, item) => {
        analyzeActions.setDirection(item.key);
    }

    const handleChangeIsknDate = (isknDate_) => {
        if (isknDate !== isknDate_) {
            analyzeActions.setOpsubItem(null);
            analyzeActions.setIsknDate(isknDate_);
        }
    }

    const handleChangeIsknDatechecked = (isknDateChecked_) => {
        analyzeActions.setIsknDateChecked(isknDateChecked_)
    }

    const handleChangeOpsub = (opsubItem) => {
        analyzeActions.setOpsubItem(opsubItem);
    }

    return (
        <OverviewPanel title="VÝBĚR VLASTNÍKA" loaded={true} panelWidth="700px">
            <Stack className={classNames.content} tokens={{childrenGap: 8}}>
                <IsknDataComboBox
                    isknDate={isknDate}
                    title="Datová sada ISKN pro výběr vlastníka"
                    onChange={handleChangeIsknDate}
                />
                {(isknDate && (opsubItems.length === 0))
                    ? <div>Načítám seznam vlastníků...</div>
                    : null
                }
                {(isknDate && (opsubItems.length > 0))
                    ? <>
                        <Stack horizontal>
                            <Stack.Item grow>Počet načtených vlastníků: {opsubItems.length}</Stack.Item>
                        </Stack>
                        <SelectOpsubComboBox
                            opsubItems={opsubItems}
                            onChange={handleChangeOpsub}
                        />
                    </>
                    : null
                }
                {(isknDate && opsubItem)
                    ? <Stack tokens={{childrenGap: 8}}>
                        <Stack>
                            <Text bold>Vybraný vlastník</Text>
                            <Stack horizontal wrap tokens={{childrenGap: 4}}>
                                <Text>{opsubItem._name}, </Text>
                                <Text>{opsubItem._rcico}, </Text>
                                <Text>{opsubItem._address}</Text>
                            </Stack>
                        </Stack>
                        <Dropdown
                            selectedKey={direction}
                            options={[
                                {key: 'forward', text: 'Do budoucnosti'},
                                {key: 'backward', text: 'Do minulosti'}
                            ]}
                            onChange={handleChangeDirection}
                            label="Časový směr analýzy"
                        />
                        <IsknDataCheckbox
                            isknDatesForAnalyze={getIsknDatesForAnalyze()}
                            isknDatesChecked={isknDatesChecked}
                            onChange={handleChangeIsknDatechecked}
                        />
                        <Stack.Item className={classNames.analyzeButton}>
                            <PrimaryButton
                                text="Analyzovat vlastnictví"
                                disabled={!canAnalyze()}
                                onClick={handleClickAnalyze}
                            />
                        </Stack.Item>
                    </Stack>
                    : null
                }
            </Stack>
        </OverviewPanel>
    );
}

export default OverviewPanelOpsub;
